/* RESPONSIBLE TEAM: team-data-foundations */
import { inject as service } from '@ember/service';
import { readOnly, map } from '@ember/object/computed';
import { computed } from '@ember/object';
import Predicate from 'predicates/models/predicate';
export default Predicate.extend({
  appService: service(),
  intl: service(),
  plansApi: service(),
  isEditable: true,
  genericType: 'plan',
  isPlanType: true,
  defaultComparison: 'eq',
  plans: readOnly('appService.app.plans'),
  options: map('plans', function (plan) {
    return {
      label: plan.name,
      value: plan.id
    };
  }),
  isValid: computed('value', 'comparison', function () {
    if (['known', 'unknown'].includes(this.comparison)) {
      return true;
    }
    return ['eq', 'ne'].includes(this.comparison) && !!this.value;
  }),
  planName: undefined,
  description: computed('attribute', 'comparison', 'type', 'value', 'intl.locale', 'planName', function () {
    this.loadPlanName();
    return this.planName || this.intl.t('common.predicates.plans.loading');
  }),
  async loadPlanName() {
    let planName = await this.plansApi.planName(this.value);
    this.set('planName', planName);
  },
  getDefaultValue() {
    return this.get('options.firstObject.value') ?? undefined;
  },
  _initializeValueForComparison(comparison) {
    if (['known', 'unknown'].includes(comparison)) {
      return null;
    } else if (this.hasNoValue) {
      return this.getDefaultValue();
    } else {
      return this.value;
    }
  }
});